<script lang="ts" setup>
import type { PrMobileHeaderLink } from '#core/components/page/PrMobileHeader.vue'
import type { IconClass } from '#core/types'

interface Props {
  title?: string
  icon?: string
  iconClass?: IconClass
}

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<Props>()

const mobileLinks: PrMobileHeaderLink[] = [
  {
    label: 'Forgd Academy',
    to: '/academy',
    imageIcon: '/lessons-and-faqs-icon-colored.svg',
    shouldHighlight: (path: string) => path.startsWith('/academy'),
  },
]
</script>

<template>
  <NuxtLayout name="dashboard" :title="title" :icon="icon" :contact="false" container-class="!p-0">
    <template #mobile-header>
      <PrMobileHeader
        :title="props.title"
        :icon="props.icon"
        :icon-class="props.iconClass"
        :links="mobileLinks"
      />
    </template>
    <template v-if="$slots.sidebar" #sidebar>
      <slot name="sidebar" />
    </template>
    <template v-if="$slots.subheader" #subheader>
      <slot name="subheader" />
    </template>
    <slot />
  </NuxtLayout>
</template>
